<template>
  <a-modal
    :title="title"
    :width="400"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="字典名称" prop="baseName">
          <a-input v-model="form.baseName" placeholder="请输入字典名称" />
        </a-form-model-item>
        <a-form-model-item label="字典值" prop="baseCode">
          <a-input v-model="form.baseCode" placeholder="请输入字典值" />
        </a-form-model-item>
        <a-form-model-item label="排序" prop="seq" v-if="type == 'edit'">
          <a-input v-model="form.seq" placeholder="请输入排序" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { Setting } from "@/api";
export default {
  components: {},
  data() {
    return {
      title: "",
      type: "",
      confirmLoading: false,
      visible: false,
      formData: {
        baseName: "",
        baseCode: "",
      },
      form: {},
      rules: {
        baseName: [
          {
            required: true,
            message: "请输入字典名称!",
            trigger: "change",
          },
        ],
        baseCode: [
          {
            required: true,
            message: "请输入字典值!",
            trigger: "change",
          },
        ],
        seq: [
          {
            required: true,
            message: "请输入排序值!",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    open(type, data, baseTypeCode) {
      this.type = type;
      this.title = type == "edit" ? "编辑字典明细" : "新增字典明细";
      this.visible = true;
      this.form = JSON.parse(JSON.stringify(this.formData));
      this.form.baseTypeCode = baseTypeCode;
      if (type == "edit" && data) {
        this.form = JSON.parse(JSON.stringify(data));
        delete this.form.createTime;
        delete this.form.updateTime;
      }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));

          this.addsave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 添加提交
    addsave(data) {
      this.confirmLoading = true;
      Setting.sysCodeTypeSave(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage("操作成功！", "success");
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.$refs.ruleForm.resetFields();
      this.form = JSON.parse(JSON.stringify(this.formData));
    },
  },
};
</script>
